module.exports = __webpack_public_path__ + "img/1-noparticipated.e8028e08.png";